// const numberOfCertifications = 8;
const aboutMe = {
  description: `I'm an avid hiker, biker, backcountry camper, and hanger (Hammocking). I Love all things outdoors! I have a passion for learning, and love to be challenged. I am happiest when I am creating something. My current experience includes REST API, MERN, CRUD, CI/CD, TDD. `,
  languages: ['TypeScript', 'JavaScript', 'Git', 'React', 'Node', 'React Native', 'Mongo DB', 'Express', 'SQL', 'HTML5', 'CSS3', 'Jest', 'Mocha', 'Cypress E2E']
};

// I have a very diverse career background that has left me with a very unique and large skill set. I have multiple (${numberOfCertifications} at the moment) certifications in tech related fields. I can read the shit out of documentation! 😍

export default aboutMe;